export default __webpack_public_path__ + "static/broadband-select-facts-5179f5c84872f775838ec8b8ada06346.pdf";